export const parseIntSafe = (n: string, base = 10): number | null => {
  const int = parseInt(n, base);
  if (isNaN(int) || !isFinite(int)) return null;
  return int;
};
